import httpHelper from "@/helpers/httpHelper";

const menuService = {
    async get(id) {
        return await httpHelper.get("/WebApi/Menu/Get", {id});
    }
};

export default menuService;